import { PREBUILT_PATHWAYS } from '../data/pathways';
import type { AgeBand, Pathway } from '../types';

/**
 * The single source of truth for "which pathway is this child on".
 *
 * The childStore `pathways` array is only populated during onboarding and is
 * never rehydrated, so every reload used to fall back to PREBUILT_PATHWAYS[0]
 * ('math-fractions-8-12') — showing streak 0 and serving fractions to everyone.
 * Resolve against the static catalog instead; it always exists.
 */
export function resolveActivePathway(
  child: { activePathwayId: string | null; ageBand: AgeBand } | null,
): Pathway {
  if (child?.activePathwayId) {
    const chosen = PREBUILT_PATHWAYS.find((p) => p.id === child.activePathwayId);
    if (chosen) return chosen;
  }
  if (child) {
    const banded = PREBUILT_PATHWAYS.find((p) => p.ageBand === child.ageBand);
    if (banded) return banded;
  }
  return PREBUILT_PATHWAYS[0];
}
